import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

/** Completion ring. Colors come from design tokens so it follows the theme. */
const ProgressBar = (props: { val: number }) => {
  const { val } = props;
  const complete = val >= 100;
  return (
    <div>
      <CircularProgressbar
        value={val}
        text={`${val}%`}
        strokeWidth={10}
        styles={{
          root: {},
          path: {
            stroke: complete ? "rgb(var(--zs-success))" : "rgb(var(--zs-primary))",
            strokeLinecap: "round",
            transition: "stroke-dashoffset 0.5s ease 0s",
            transform: "rotate(0.25turn)",
            transformOrigin: "center center",
          },
          trail: {
            strokeLinecap: "round",
            transform: "rotate(0.25turn)",
            transformOrigin: "center center",
            stroke: "rgb(var(--zs-surface-hover))",
          },
          text: {
            fill: "rgb(var(--zs-ink))",
            fontSize: "22px",
            fontWeight: 700,
            fontFamily: "var(--zs-font-display)",
          },
        }}
      />
    </div>
  );
};

export default ProgressBar;
